import { Button } from '@/components/ui/button';
import { Sparkles, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTrialDays } from '@/hooks/useTrialDays';

interface FinalCTAProps {
  onOpenDecommissioning: () => void;
}

export const FinalCTA = ({ onOpenDecommissioning }: FinalCTAProps) => {
  const { t } = useTranslation();
  const { trialDays, loading: trialDaysLoading } = useTrialDays();

  return (
    <div className="mb-16 animate-fade-in">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background gradient */}
          <div className="absolute inset-0 bg-newsletter-gradient opacity-10" />
          <div className="absolute inset-0 bg-gradient-to-br from-newsletter-primary/20 via-newsletter-secondary/10 to-newsletter-accent/20 backdrop-blur-3xl" />
          
          {/* Content */}
          <div className="relative p-8 md:p-12 text-center border border-newsletter-primary/30">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-newsletter-accent/20 border border-newsletter-accent/30 mb-6">
              <Sparkles className="w-4 h-4 text-newsletter-accent" />
              <span className="text-sm font-medium text-newsletter-accent">
                {t('finalCTA.badge')}
              </span>
            </div>

            <h2 className="text-2xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-foreground to-newsletter-primary bg-clip-text text-transparent">
              {t('finalCTA.headline')}
            </h2>

            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              {t('finalCTA.subheadline')}
            </p>

            <Button
              onClick={onOpenDecommissioning}
              size="lg"
              variant="premium"
              className="h-14 px-8 text-base font-semibold rounded-2xl shadow-newsletter group"
            >
              <Sparkles className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
              {t('finalCTA.button')}
            </Button>

            <div className="flex items-center justify-center gap-2 mt-6 text-sm text-muted-foreground">
              <CheckCircle className="w-4 h-4 text-green-600" />
              <span>{trialDaysLoading ? '...' : t('finalCTA.trustLine', { days: trialDays })}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
